module.exports = __webpack_public_path__ + "b325b56a3d7fe9b708a2db7f6cc828c4.png";